module.exports = __webpack_public_path__ + "static/Choix_Du_Consommateur_French-fe2f6b930761fb5fbd350821e1cce34c.png";